import {Checkbox} from "@mui/material";
import React from "react";
import {GroupedRowState} from "../../../classes/GroupedRowState";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../../stores";

type Props = {
    groupedRow: GroupedRowState
};
export const GroupSelectionBox: React.FC<Props> = observer(({groupedRow}) => {
    const {categorizationReviewStore} = useStores()
    const selectionController = categorizationReviewStore.reviewPageController.reviewPageSelectionController;
    return <Checkbox
        checked={groupedRow.hasSelection}
        indeterminate={groupedRow.selectionState === 'some'}
        onClick={() => {
            if (!groupedRow.hasPartsOutsideView) {
                selectionController.onSetSelectionOfSupplierGroup(groupedRow, !groupedRow.isAllSelected);
            } else {
                switch (groupedRow.selectionState) {
                    case 'all':
                        selectionController.onSetSelectionOfSupplierGroup(groupedRow, false);
                        break;
                    case 'none':
                    case 'some':
                        selectionController.onSetSelectionOfSupplierGroup(groupedRow, true);
                        break;
                }
            }
        }}
        disabled={groupedRow.isLoadingRows || groupedRow.combinedStateVisual.selectionDisabled}
    />
})
